// extracted by css-extract-rspack-plugin
export default {"container":"u2E6IwbnWFw4o_dd","banner":"HuFtW_ARit4sWAF6","branding":"STbYERIYkJICvosD","actions":"gpSq3yAx_X8XtGNt","main":"eiakkbX1l5ArUpR0","footer":"_k48mfwJfr0nb_ER"};